export class Settings {
    public static DEBOUNCE_TIME = 3000;
    public static MIN_INPUT_LENGTH = 3;
    public static MAX_DISPLAYED_ITEMS_IN_DROP_DOWN = 20;
    public static SEARCH_DEBOUNCE_TIME = 800;

}
